import * as React from "react";
import { memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSCircle = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 30 30",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "#fff",
		stroke: "currentColor",
		strokeWidth: 2,
		d: "M14.87 1c7.659 0 13.869 6.21 13.87 13.87s-6.21 13.87-13.87 13.87C7.21 28.738 1 22.528 1 14.87 1 7.21 7.21 1 14.87 1Z"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "m16.947 13.733-2.593-.573c-.768-.186-1.33-.422-1.655-.691-.341-.287-.495-.658-.495-1.096 0-.523.24-.944.751-1.282.512-.337 1.126-.489 1.877-.489.75 0 1.023.085 1.399.27.375.186.682.422.921.725.222.304.392.607.478.944l3.258-.37c-.239-1.316-.887-2.361-1.91-3.137-1.024-.775-2.423-1.163-4.214-1.163s-2.286.186-3.208.573c-.921.388-1.655.928-2.166 1.636-.512.708-.768 1.534-.768 2.495 0 1.13.341 2.057 1.04 2.799s1.775 1.264 3.242 1.568l2.593.556c.7.152 1.211.371 1.553.674.34.287.494.658.494 1.096s-.256.961-.784 1.315c-.512.355-1.195.54-2.048.54s-1.5-.186-2.013-.54-.853-.876-1.006-1.584l-3.498.337c.222 1.433.887 2.546 2.03 3.338 1.127.793 2.628 1.197 4.487 1.197 1.86 0 2.389-.202 3.361-.624.973-.421 1.74-.994 2.286-1.736a4.25 4.25 0 0 0 .836-2.58c0-1.113-.358-2.006-1.057-2.697-.7-.692-1.775-1.18-3.208-1.5z"
	})]
});
const Memo = memo(SvgSCircle);
export default Memo;
